var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusBarSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 44,
    viewBox: "0 0 375 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_14)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375 0H0V44H375V0Z",
    fill: "#CAE5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M353 0H22C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44H353C365.15 44 375 34.1503 375 22C375 9.84974 365.15 0 353 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M361 13H334V33H361V13Z",
    fill: "#E78D7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.5 17.5H338.5C337.119 17.5 336 18.6193 336 20V26.5C336 27.8807 337.119 29 338.5 29H355.5C356.881 29 358 27.8807 358 26.5V20C358 18.6193 356.881 17.5 355.5 17.5ZM337 20C337 19.1716 337.672 18.5 338.5 18.5H355.5C356.328 18.5 357 19.1716 357 20V26.5C357 27.3284 356.328 28 355.5 28H338.5C337.672 28 337 27.3284 337 26.5V20ZM360.25 23.0015C360.25 22.0761 359.747 21.2682 359 20.8359V25.167C359.747 24.7348 360.25 23.9268 360.25 23.0015Z",
    fill: "#151515",
    fillOpacity: 0.38
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339 19.5H355C355.552 19.5 356 19.9477 356 20.5V26C356 26.5523 355.552 27 355 27H339C338.448 27 338 26.5523 338 26V20.5C338 19.9477 338.448 19.5 339 19.5Z",
    fill: "#413F5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M312 13H292V33H312V13Z",
    fill: "#E78D7E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M333 13H313V33H333V13Z",
    fill: "#E78D7E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.871 20.6993L330.864 20.4645C328.805 18.6217 326.16 17.6055 323.379 17.6055C320.592 17.6055 317.939 18.6275 315.877 20.4797L315.871 20.7143L317.09 21.9356L317.311 21.9428C318.989 20.4657 321.13 19.6529 323.379 19.6529C325.621 19.6529 327.756 20.4602 329.431 21.9282L329.652 21.9208L330.871 20.6993ZM328.192 23.1327L328.202 23.3707L326.979 24.5958L326.764 24.6078C325.803 23.8399 324.618 23.4225 323.379 23.4225C322.133 23.4225 320.94 23.845 319.977 24.6215L319.762 24.6099L318.539 23.3852L318.549 23.1476C319.898 22.0023 321.597 21.375 323.379 21.375C325.153 21.375 326.845 21.9967 328.192 23.1327ZM323.476 28.1052H323.248L321.219 26.073C321.148 26.0021 321.158 25.8844 321.24 25.8266C321.864 25.3852 322.606 25.1484 323.378 25.1484C324.141 25.1484 324.876 25.3802 325.496 25.8129C325.578 25.8705 325.589 25.9887 325.518 26.0599L323.476 28.1052Z",
    fill: "#413F5E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.75 17.75C308.198 17.75 307.75 18.1977 307.75 18.75V27.25C307.75 27.8023 308.198 28.25 308.75 28.25H309.75C310.302 28.25 310.75 27.8023 310.75 27.25V18.75C310.75 18.1977 310.302 17.75 309.75 17.75H308.75ZM303 21C303 20.4477 303.448 20 304 20H305C305.552 20 306 20.4477 306 21V27.25C306 27.8023 305.552 28.25 305 28.25H304C303.448 28.25 303 27.8023 303 27.25V21ZM299.25 22.5C298.698 22.5 298.25 22.9477 298.25 23.5V27.25C298.25 27.8023 298.698 28.25 299.25 28.25H300.25C300.802 28.25 301.25 27.8023 301.25 27.25V23.5C301.25 22.9477 300.802 22.5 300.25 22.5H299.25ZM294.5 24.5C293.948 24.5 293.5 24.9477 293.5 25.5V27.25C293.5 27.8023 293.948 28.25 294.5 28.25H295.5C296.052 28.25 296.5 27.8023 296.5 27.25V25.5C296.5 24.9477 296.052 24.5 295.5 24.5H294.5Z",
    fill: "#413F5E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 19,
    width: 11,
    height: 11
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9552 29.5L74.5 19L64 23.5448H69.9552V29.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9552 29.5H63.9552L75.4616 31.8833L69.9552 29.5ZM74.5 19L80.0063 21.3833L86.0274 7.4726L72.1167 13.4937L74.5 19ZM64 23.5448L61.6167 18.0384L64 29.5448V23.5448ZM69.9552 23.5448H75.9552V17.5448H69.9552V23.5448ZM75.4616 31.8833L80.0063 21.3833L68.9937 16.6167L64.4489 27.1167L75.4616 31.8833ZM72.1167 13.4937L61.6167 18.0384L66.3833 29.0511L76.8833 24.5063L72.1167 13.4937ZM64 29.5448H69.9552V17.5448H64V29.5448ZM63.9552 23.5448V29.5H75.9552V23.5448H63.9552Z",
    fill: "#413F5E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusBarSolution);
export default __webpack_public_path__ + "static/media/StatusBarSolution.9cb365b70f55f632236d001d2bf6516b.svg";
export { ForwardRef as ReactComponent };